/* eslint max-len:0 max-params:0 */
angular.module('qkr').controller('TransactionMerchantController', ($scope, $rootScope, $uibModalInstance, $timeout,
                                                                   savedReport, reportService,
                                                                   appConfig, reportsErrorService, utils, merchantService,
                                                                   gettextCatalog, reportInfo, messageService,
                                                                   APP_CONSTANT, outlets) => {

    const vm = $scope;
    const now = new Date().getTime();

    const defaultScheduleInterval = 'daily';
    const defaultScheduleHour = 17;
    const defaultScheduleMinute = 0;
    const defaultScheduleDay = utils.getDaysOfWeek()[0].name;
    const defaultScheduleDayOfMonth = 1;

    const isUpdating = Boolean(savedReport);

    vm.daysOfMonth = reportService.getDaysOfMonth();
    vm.daysOfWeek = utils.getDaysOfWeek();  // Drop down menu to choose which day to generate weekly report
    vm.days = utils.getDaysOfWeekWithSelected();   // Used to select which days a daily report should be generated on
    vm.scheduleIntervals = [];
    vm.hours = reportService.getHours();
    vm.minutes = reportService.getMinutes();

    vm.templateReport = [];
    vm.templateReportTemplate = [];

    vm.form = {};

    // Outlets to show in the popup, they are in the array because there are one popup for 2 views, to keep the state
    // From each other
    vm.outlets = [];

    vm.NON_SCHEDULE = 0;
    vm.SCHEDULE = 1;

    vm.selectAll = [];

    vm.sendProtocolOptions = [{description: 'Email', type: 'EMAIL'}, {description: 'SFTP', type: 'SFTP'},
        {description: 'Amazon S3', type: 'S3'}];

    vm.transactionReportSettings = {
        reportWaiting: false,
        reportUrl: '',
    };

    vm.transactionReport = {
        date: {
            startDate: now,
            startTime: reportService.getDateTime(0, 0, 0),
            endDate: now,
            endTime: reportService.getDateTime(23, 59, 59)
        },
        startTime: null,
        endTime: null,
        reportSpec: {
            reportSubType: APP_CONSTANT.REPORT_TRANSACTION_DETAILS,
            merchantLocs: [],
            reportFileType: 'xls'
        }
    };

    vm.transactionReportTemplate = {
        reportSpec: {
            scheduleInterval: defaultScheduleInterval,
            scheduleHour: defaultScheduleHour,
            scheduleDay: defaultScheduleDay,
            scheduleDayOfMonth: defaultScheduleDayOfMonth,
            emailList: [],
            scheduleMinute: defaultScheduleMinute,
            reportSubType: APP_CONSTANT.REPORT_TRANSACTION_DETAILS,
            merchantLocs: [],
            reportFileType: 'xls',
            sendProtocol: 'EMAIL'
        }
    };

    function init() {
        vm.showEmailOption = appConfig.isMCAdmin;

        const merchant = merchantService.merchantInfo;

        // Get the beneficiary field names
        vm.merchant = merchant;
        vm.showFulfilledByCheck = merchantService.behaviour(merchant, 'transReportPage.showFulfilledByCheck');
        vm.showFulfilledDateCheck = merchantService.behaviour(merchant, 'transReportPage.showFulfilledDateCheck');
        vm.showPosItemCodeCheck = merchantService.behaviour(merchant, 'transReportPage.showPosItemCodeCheck');
        vm.showCSVOption = !merchantService.behaviour(merchant, 'transReportPage.showDepartments');

        if (merchantService.behaviour(merchant, 'transReportPage.showExtendedScheduleIntervals')) {
            vm.scheduleIntervals = reportService.getExtendedScheduleIntervals();
        } else {
            vm.scheduleIntervals = reportService.getScheduleIntervals();
        }

        // Get the beneficiary custom fields from the sticker report groupByList

        if(merchantService.merchantInfo.businessCategory.name === 'School') {
            reportService.getStickerReportFilters()
                .then(stickerReportFilters => {

                    vm.templateReport.headers =
                        transformHeader(angular.copy(stickerReportFilters.groupByList));
                    vm.templateReportTemplate.headers =
                        transformHeader(angular.copy(stickerReportFilters.groupByList));

                    if (isUpdating) {
                        vm.transactionReportTemplate.reportSpec = savedReport;
                        if (vm.transactionReportTemplate.reportSpec.sendProtocolParams) {
                            vm.transactionReportTemplate.reportSpec.sendProtocolParams.password = '';
                        }// QKRD-6040 clear this down to force entry on each edit
                        // Use radix parameters when calls parseInt, base 10
                        vm.transactionReportTemplate.reportSpec.scheduleDayOfMonth =
                            parseInt(vm.transactionReportTemplate.reportSpec.scheduleDayOfMonth, 10);
                        utils.setSelectedDays(vm.transactionReportTemplate.reportSpec.scheduleDay, vm.days);
                        for (let i = 0; i < vm.templateReportTemplate.headers.length; i++) {
                            vm.templateReportTemplate.headers[i].selected =
                                savedReport.customFields.includes(vm.templateReportTemplate.headers[i].name);
                        }
                        setReportFileType(savedReport);
                    }
                }, (reason) => {
                    messageService.error('service called failure', reason);
                });
        }

        const totalOutlets = outlets.length;

        // Array of objects, it copy both arrays, because they are independent
        vm.outlets[vm.NON_SCHEDULE] = angular.copy(outlets);
        vm.outlets[vm.SCHEDULE] = angular.copy(outlets);

        // Set all SelectedOutlets that's the default, update is just for schedule reports
        if (isUpdating) {
            vm.popupObject.setCurrentPopup(vm.SCHEDULE);

            angular.forEach(vm.outlets[vm.SCHEDULE], (outlet) => {
                angular.forEach(savedReport.merchantLocs, (savedOutlet) => {
                    if (outlet.id === savedOutlet.id) {
                        outlet.selected = true;
                        vm.popupObject.manageSelectedOutlet(outlet.selected);
                    }
                });
            });

            // Just for schedules, not saved
            // Set the new field selected to true for each outlet
            for (var i = 0; i < totalOutlets; i++) {
                var outletNon = vm.outlets[vm.NON_SCHEDULE][i];

                outletNon.selected = true;

                vm.popupObject.setCurrentPopup(vm.NON_SCHEDULE);
                vm.popupObject.manageSelectedOutlet(outletNon.selected);
            }
        } else {
            // Set the new field selected to true for each outlet
            for (var i = 0; i < totalOutlets; i++) {
                var outletNon = vm.outlets[vm.NON_SCHEDULE][i];
                const outlet = vm.outlets[vm.SCHEDULE][i];

                // Set up all outlet to selected, schedule and non_schedule
                outletNon.selected = true;
                outlet.selected = true;

                vm.popupObject.setCurrentPopup(vm.NON_SCHEDULE);
                vm.popupObject.manageSelectedOutlet(outletNon.selected);

                vm.popupObject.setCurrentPopup(vm.SCHEDULE);
                vm.popupObject.manageSelectedOutlet(outlet.selected, vm.SCHEDULE);
            }
        }

    }

    vm.popupObject = (function() {
        // Current popup in the screen, it set when it opens the popup
        let currentPopupIndex;

        // Privates arrays, each popup has it own values
        let arrCountSelected = [0, 0], arrShowPopup = [false, false];

        return {

            getCountSelected(popupIndex) {
                // If it is called not from the popup it needs pass popupIndex
                return popupIndex !== undefined ? arrCountSelected[popupIndex] : arrCountSelected[currentPopupIndex];
            },

            getCurrentPopup() {
                return arrShowPopup[currentPopupIndex];
            },
            getCurrentPopupIndex() {
                return currentPopupIndex;
            },
            manageSelectedOutlet(selected) {
                if (!selected) {
                    arrCountSelected[currentPopupIndex] = arrCountSelected[currentPopupIndex] - 1;
                } else {
                    arrCountSelected[currentPopupIndex] = arrCountSelected[currentPopupIndex] + 1;
                }

                // If count is < length then set the check to false
                if (arrCountSelected[currentPopupIndex] < vm.outlets[currentPopupIndex].length) {
                    // Ng-models for the checkbox
                    vm.selectAll[currentPopupIndex] = false;
                } else {
                    vm.selectAll[currentPopupIndex] = true;
                }
            },
            manageShowPopup(show) {
                arrShowPopup[currentPopupIndex] = show;

                // Cannot have more than 1 popup visible
                if (show) {
                    angular.forEach(arrShowPopup, (showing, key) => {
                        if (currentPopupIndex !== key) {
                            arrShowPopup[key] = false;
                        }
                    });
                }

                return arrShowPopup[currentPopupIndex];
            },
            manageSelectAll(all) {
                // Select all or none btn
                vm.selectAll[currentPopupIndex] = all;
            },
            setCurrentPopup(popupIndex) {
                currentPopupIndex = popupIndex;
            },
            selectAllNone(selected) {
                if (!selected) {
                    // CountFiltered = 0;
                    arrCountSelected[currentPopupIndex] = 0;
                } else {
                    arrCountSelected[currentPopupIndex] = vm.outlets[currentPopupIndex].length;
                }
            }

        };
    })();

    vm.openFilterPopup = function(popupIndex) {
        // Set the currentIndex popup, in this case the object knows which one is the opened popup
        vm.popupObject.setCurrentPopup(popupIndex);

        if (vm.popupObject.getCountSelected() === 0) {
            // vm.selectAll = false;
            vm.popupObject.manageSelectAll(false);
        }
        // Default the selected one to the first in the list
        vm.popupObject.manageShowPopup(true);
    };

    vm.closePopupFilter = function() {
        vm.popupObject.manageShowPopup(false);
    };

    // This function is to set that array that's going to be sent , It's going to loop over because is easier to keep...
    // Than remove and add
    function setSelectedOutlets(selectedOutlets) {
        vm.outletSelected = [];

        if (!selectedOutlets) {
            angular.forEach(vm.outlets[vm.popupObject.getCurrentPopupIndex()], (outlet) => {
                if (outlet.selected) {
                    vm.outletSelected.push({id: outlet.id});
                }
            });
        } else {
            vm.outletSelected = selectedOutlets;
        }
    }

    vm.unselectedFiltered = function(selected) {
        vm.popupObject.manageSelectedOutlet(selected);
    };

    vm.selectAllOrNone = function(selected) {
        angular.forEach(vm.outlets[vm.popupObject.getCurrentPopupIndex()], (outlet) => {
            outlet.selected = selected;
        });

        vm.popupObject.selectAllNone(selected, vm.popupObject.getCurrentPopupIndex());
    };

    vm.getNumberOutletText = function() {
        return vm.popupObject.getCountSelected(vm.SCHEDULE) === 0;
    };

    var poll = function(id, format, reportType) {
        const timeoutPoll = $timeout(() => {
            // Poll for report
            reportService.pollReport(id)
                .then((promise) => {
                        // Check if error on the report
                        if (promise.error) {
                            handleGenerateReportError(promise.error);
                        } else if (promise.reportType === 'no-data') {
                            vm.form.transactionReportForm.errors = {generate: gettextCatalog.getString('No data for these criteria')};
                            vm.transactionReportSettings.reportWaiting = false;
                        }
                        // Check if complete, otherwise poll again
                        else if (promise.percentComplete === 100) {
                            vm.form.transactionReportForm.errors = {};
                            vm.transactionReportSettings.reportWaiting = false;
                            vm.transactionReportSettings.reportUrl = appConfig.apiUrl + 'reportControl/' + promise.id + '/' + format;
                            window.location = vm.transactionReportSettings.reportUrl;
                        } else {
                            poll(id, format, reportType);
                        }
                    },
                    (error) => {
                        handleGenerateReportError(error);
                    });
        }, 2500);

        // When the DOM element is removed from the page, AngularJS will trigger
        // The $destroy event on
        // The scope. This gives us a chance to cancel any pending timer that we
        // May have.
        vm.$on(
            '$destroy',
            (event) => {
                $timeout.cancel(timeoutPoll);
            }
        );
    };

    function handleGenerateReportError (error) {
        let errors = {};

        if (vm.form.transactionReportForm.errors) {
            errors = vm.form.transactionReportForm.errors;
        }
        if (angular.isString(error)) {
            errors.generate = error;
        }
        else {
            errors.generate = gettextCatalog.getString('Error generating report');
        }
        vm.form.transactionReportForm.errors = errors;
        vm.transactionReportSettings.reportWaiting = false;
    }

    vm.generateTransactionReport = function() {
        vm.transactionReportSettings.reportWaiting = true;

        const request = angular.copy(vm.transactionReport);

        request.reportSpec.scheduleInterval = 'once';
        request.startTime = utils.dateTimeToServerDateTimeString(vm.transactionReport.date.startDate,
            vm.transactionReport.date.startTime); // Start of day
        request.endTime = utils.dateTimeToServerDateTimeString(vm.transactionReport.date.endDate,
            vm.transactionReport.date.endTime); // End of day

        request.reportSpec.customFields = [];
        if (reportInfo.reportType) {
            request.reportSpec.customFields.push('Family number');
        }
        for (const i in vm.templateReport.headers) {
            if (vm.templateReport.headers[i].selected) {
                request.reportSpec.customFields.push(vm.templateReport.headers[i].name);
            }
        }

        // Set array outletsSelected to be send, in this case is going to loop again because is another array...
        // That is going to be send
        vm.popupObject.setCurrentPopup(vm.NON_SCHEDULE);
        setSelectedOutlets();

        request.reportSpec.merchantLocs = vm.outletSelected;

        if (vm.popupObject.getCountSelected(vm.NON_SCHEDULE) === 0) {
            vm.form.transactionReportForm.errors = {outletFilterGenerate: gettextCatalog.getString('Should at least select one Outlet')};

            vm.transactionReportSettings.reportWaiting = false;
            return;
        }

        if (request.reportSpec.reportFileType === 'csv') {
            request.reportSpec.reportSubType = request.reportSpec.reportSubType + request.reportSpec.reportFileType;
        }
        delete (request.date);
        delete (request.reportSpec.reportFileType);

        reportService.generateTransactionReport(request).then(
            (promise) => {
                poll(promise.id, 'excel', 'transaction');
            },
            (error) => {
                handleGenerateReportError(error);
            }
        );
    };

    /**
     * Set the merchantLocs that are selected in the report spec (that will be
     * sent to server)
     */

    vm.saveTransactionReport = function() {
        if (!validateReport()) {
            return;
        }

        vm.saving = true;

        const request = angular.copy(vm.transactionReportTemplate.reportSpec);

        // Set array outletsSelected to be send, in this case is going to loop again because is another array...
        // That is going to be send
        vm.popupObject.setCurrentPopup(vm.SCHEDULE);
        setSelectedOutlets();

        if (request.reportFileType === 'csv') {
            request.reportSubType = request.reportSubType + '_' + request.reportFileType;
            delete (request.reportFileType);
        }

        if (request.sendProtocol === 'SFTP') {
            request.sendProtocolParamsStr = angular.toJson(request.sendProtocolParams, false);
        }

        request.merchantLocs = vm.outletSelected;

        if (request.scheduleInterval === 'daily') {
            request.scheduleDay = utils.getSelectedDaysList(vm.days);
        }

        // Are we updating or creating, if savedReport object passed to modal we
        // Are updating, otherwise we are creating
        if (!isUpdating) {
            request.id = null;
        }

        // Add selected headers to reportSped custom fields
        request.customFields = [];
        if (reportInfo.reportType) {
            request.customFields.push('Family number');
        }

        for (const i in vm.templateReportTemplate.headers) {
            if (vm.templateReportTemplate.headers[i].selected) {
                request.customFields.push(vm.templateReportTemplate.headers[i].name);
            }
        }

        reportService.saveTransactionReport(request, isUpdating)
            .then(() => {
                $uibModalInstance.close(true);
            })
            .catch(err => {
                vm.form.transactionReportForm.errors = reportsErrorService
                        .handleServerError(err.data.errors);
            }).finally(() => {
                vm.saving = false;
            });
    };

    function validateReport() {
        // Empty the errors list
        vm.errors = null;
        let valid = true;
        const errors = {};

        // Check name is set
        if (vm.form.transactionReportForm.name.$invalid) {
            errors.name = gettextCatalog.getString('Name is required');
            valid = false;
        }

        // Check at least 1 email is added
        if (vm.transactionReportTemplate.reportSpec.sendProtocol === 'EMAIL' &&
            vm.transactionReportTemplate.reportSpec.emailList.length <= 0) {
            errors.email = gettextCatalog.getString('At least 1 email address is required');
            valid = false;
        }

        const sendProtParams = vm.transactionReportTemplate.reportSpec.sendProtocolParams;
        let isSFTP = false;
        if (vm.transactionReportTemplate.reportSpec.sendProtocol === 'SFTP') {
            isSFTP = true;
        }
        if (isSFTP && sendProtParams && (sendProtParams.password == null || sendProtParams.password === '')) {
            errors.password = gettextCatalog.getString('Please enter SFTP password');
            valid = false;
        }

        if (vm.popupObject.getCountSelected(vm.SCHEDULE) === 0) {
            errors.outletFilterSave = gettextCatalog.getString('Should at least select one Outlet');

            valid = false;
        }

        vm.form.transactionReportForm.errors = errors;

        return valid;
    }

    vm.addTransactionReportEmail = function() {
        // Gets ride of validation warning
        if (vm.form.transactionReportForm.errors && vm.form.transactionReportForm.errors.email) {
            vm.form.transactionReportForm.errors.email = '';
        }
        vm.transactionReportTemplate.reportSpec.emailList.push(vm.transactionReportSettings.email);
        vm.transactionReportSettings.email = '';
    };

    vm.removeTransactionReportEmail = function(index) {
        vm.transactionReportTemplate.reportSpec.emailList.splice(index, 1);
    };

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    // Transform in a json object
    function transformHeader(groupByList) {
        const tmp = [];
        // Transform groupByList, Add selected key to all so we can use this as
        // Model for toggle on/off
        for (let i = 0; i < groupByList.length; i++) {
            const selected = true;

            tmp.push({name: groupByList[i], selected});
        }

        return tmp;
    }

    function setReportFileType(report) {
        if (report.reportSubType.indexOf('_csv', report.reportSubType.length - '_csv'.length) !== -1) {
            report.reportFileType = 'csv';
            if (report.reportSubType.indexOf(APP_CONSTANT.REPORT_TRANSACTION_DETAILS) !== -1) {
                report.reportSubType = APP_CONSTANT.REPORT_TRANSACTION_DETAILS;
            }
        } else {
            report.reportFileType = 'xls';
        }
    }

    /** Called when day is toggled in daily report */
    vm.changeDayEnabled = function(day) {
        day.selected = !day.selected;
    };

    vm.dateOptions = {
        startingDay: $rootScope.merchantInfo.contactDetails.country.weekStartingDay,
        showWeeks: false
    };

    init();
});




// WEBPACK FOOTER //
// ./src/reports/merchant/shared/transaction.merchant.controller.js